module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/AT-SPG.78edf1c9.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/AT-SPG.png
// module id = 2712
// module chunks = 11